import { PaintCommand } from '../core/EditorActions.js';

/**
 * Rectangle fill tool — drag to define rect, fills on release.
 */
export class RectTool {
  constructor(state, mapCanvas, commandHistory) {
    this.state = state;
    this.mapCanvas = mapCanvas;
    this.commandHistory = commandHistory;
    this._startX = 0;
    this._startY = 0;
    this._active = false;
  }

  onDown(tx, ty) {
    this._startX = tx;
    this._startY = ty;
    this._active = true;
    this.state.set('selectionStart', { x: tx, y: ty });
    this.state.set('selectionEnd', { x: tx, y: ty });
  }

  onMove(tx, ty) {
    if (!this._active) return;
    this.state.set('selectionEnd', { x: tx, y: ty });
  }

  onUp(tx, ty) {
    if (!this._active) return;
    this._active = false;

    const state = this.state;
    const layerIndex = state.get('activeLayerIndex');
    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    const tileId = state.get('selectedTileId');
    const stamp = state.get('stamp');

    const x1 = Math.max(0, Math.min(this._startX, tx));
    const y1 = Math.max(0, Math.min(this._startY, ty));
    const x2 = Math.min(mapW - 1, Math.max(this._startX, tx));
    const y2 = Math.min(mapH - 1, Math.max(this._startY, ty));

    const changes = [];
    for (let y = y1; y <= y2; y++) {
      for (let x = x1; x <= x2; x++) {
        let newTile = tileId;
        if (stamp) {
          const sy = (y - y1) % stamp.length;
          const sx = (x - x1) % stamp[sy].length;
          newTile = stamp[sy][sx];
        }
        const oldTile = state.getTile(layerIndex, x, y);
        if (oldTile !== newTile) {
          state.setTile(layerIndex, x, y, newTile);
          changes.push({ x, y, oldTile, newTile });
        }
      }
    }

    if (changes.length > 0) {
      const cmd = new PaintCommand(state, layerIndex, changes);
      this.commandHistory.push(cmd);
      this.mapCanvas.invalidateLayer(layerIndex);
    }

    state.set('selectionStart', null);
    state.set('selectionEnd', null);
  }
}
